import ACHInformation from './ACHInformation';

export default ACHInformation;
